<template>
    <on-click-outside :do="hide">
        <div class="w-lg">
            <button
                :class="{ 'is-active': show }"
                class="dropdown-trigger text-white font-extrabold"
                aria-label="Visa sök"
                @click="toggle"
            >
                <slot />
            </button>

            <transition name="slide-down">
                <div
                    v-show="show"
                    class="dropdown-content bg-white shadow-dropdown"
                >
                    <slot name="dropdown-content" />
                </div>
            </transition>

            <portal v-if="show" to="modals">
                <div class="fixed h-screen w-screen pin-t pin-l bg-modal" style="z-index: -1;" />
            </portal>
        </div>
    </on-click-outside>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
            };
        },
        methods: {
            toggle() {
                this.show = ! this.show;
            },
            hide() {
                this.show = false;
            },
        },
    };
</script>